module.exports = __webpack_public_path__ + "static/img/eco.ae5c6e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eco.png
// module id = EMyR
// module chunks = 0